module.exports = __webpack_public_path__ + "assets/img/img316.7859ec52.png";